<div class="isc-filter-form ds">
  <div class="accounts-filter" *appIsDesktop>
    <div class="search-row">
      <div class="filters-container">
        <ds-textfield class="full-flex no-subscript"
          id="searchField" (click)="openAdvancedFilteringDialog()"
          [control]="searchForm.controls.displayedSearchValue" end_adornment_type="icon"
          end_adornment_value_icon="search" [placeholder]="appStrings.accounts_search"
        ></ds-textfield>
        @if (currentSearchText || clearFiltersNeeded) {
          <div class="filters-container-text">
            <ds-divider class="vertical-divider" [vertical]="true"></ds-divider>
            <div class="text-align">
              <span id="showResults">
                {{ appStrings.accounts_showingResultsFor }}
                @if (currentSearchText) {
                  <span>"{{ currentSearchText }}"</span>
                }
                @if (clearFiltersNeeded && !currentSearchText) {
                  <span>{{ appStrings.quotesYourFilters }}</span>
                }
              </span>
            </div>
            <ds-divider class="vertical-divider" [vertical]="true"></ds-divider>
            <div class="text-align">
              <span id="clearAllFilters" class="clickable" (click)="clearFilters()">
                {{ appStrings.accounts_clearFilters }}
              </span>
            </div>
          </div>
        }
      </div>
      @if (isOnline) {
        <ds-button id="accountsButtonNewLead"
          size="medium" type="primary" variant="label-only"
          [label]="appStrings.accounts_buttonNewLead" (onClick)="handleNewLead()"
        ></ds-button>
      }
    </div>
    @if (showMyCustomersCheckbox) {
      <ds-checkbox id="myCustomersCheckbox" class="my-customers-checkbox"
        [label]="appStrings.accounts_showMyCustomer" [control]="searchForm.controls.myCustomers"
        (change)="onMyCustomersChange()"
      ></ds-checkbox>
    }
  </div>

  <div class="mobile-layout" *appIsMobile>
    <ds-paper elevation="elevation_none"
      borderRadius="radius_XS" outline="outlined" insidePaddingTop="top-spacing_S"
      insidePaddingBottom="bottom-spacing_S" insidePaddingLeft="left-spacing_S"
      insidePaddingRight="right-spacing_S"
      >
      <div class="mobile-search">
        <ds-textfield class="full-flex no-subscript"
          (click)="openAdvancedFilteringDialog()" [control]="searchForm.controls.displayedSearchValue"
          end_adornment_type="icon" end_adornment_value_icon="search"
          placeholder="{{ appStrings.accounts_search }}"
        ></ds-textfield>
        @if (isOnline) {
          <ds-button class="add-button"
            shape="square" size="medium" type="primary"
            variant="icon-only" icon="add"
            iconPosition="left" iconStyle="material-icons"
            (onClick)="handleNewLead()"
          ></ds-button>
        }
      </div>
    </ds-paper>

    <div id="mobileTitle" class="title">
      <typography variant="mat-headline-4" weight="bold"> {{ appStrings.accounts_title }}</typography>
    </div>

    @if (showMyCustomersCheckbox) {
      <div class="mobile-my-customers">
        <ds-checkbox id="myCustomersCheckboxMobile"
          [label]="appStrings.accounts_showMyCustomer" [control]="searchForm.controls.myCustomers"
          (change)="onMyCustomersChange()"
        ></ds-checkbox>
      </div>
    }

    @if (currentSearchText || clearFiltersNeeded) {
      <div class="mobile-results">
        <span class="filters-text">
          {{ appStrings.accounts_showingResultsFor }}
          @if (currentSearchText) {
            <span>"{{ currentSearchText }}".</span>
          }
          @if (clearFiltersNeeded && !currentSearchText) {
            <span>{{ appStrings.quotesYourFilters }}</span>
          }
        </span>
        <span id="clearAllFiltersMobile" class="clickable" (click)="clearFilters()">
          {{ appStrings.accounts_clearFilters }}
        </span>
      </div>
    }
  </div>
</div>
